class AnimateSticky extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.onScrollHandler = this.onScroll.bind(this);

    window.addEventListener('scroll', this.onScrollHandler, false);
    this.onScrollHandler();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    let element = document.querySelector('.product .product-form__submit');
    if (window.getComputedStyle(element, null).display == 'none') {
      element = document.querySelector('.klaviyo-bis-trigger');
    }
    let scrollPosition =
      window.pageYOffset ||
      window.scrollY ||
      document.body.scrollTop ||
      document.documentElement.scrollTop;
    //to make sure the sticky ATC show only after scroll after ATC, not before
    const qtyElm = document.querySelector('.product quantity-input');
    //to make sure the sticky ATC show only after scroll after ATC, not before
    if (!this.isInViewport(element) & (scrollPosition > 150)) {
      if (qtyElm) {
        if (!this.isInViewport(qtyElm)) {
          requestAnimationFrame(this.reveal.bind(this));
        }
      } else {
        requestAnimationFrame(this.reveal.bind(this));
      }
    } else {
      requestAnimationFrame(this.reset.bind(this));
    }
  }

  reveal() {
    this.setAttribute('animate', '');
  }

  reset() {
    this.removeAttribute('animate');
  }

  // Determine if an element is in the visible viewport
  isInViewport(element) {
    var rect = element.getBoundingClientRect();
    var html = document.documentElement;
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || html.clientHeight) &&
      rect.right <= (window.innerWidth || html.clientWidth)
    );
  }
}
customElements.define('animate-sticky', AnimateSticky);
